// frontend/src/components/FaceCard.js

import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

function FaceCard({ face }) {
  const imageUrl = face.imageUrl ? face.imageUrl : 'https://via.placeholder.com/150?text=No+Image'; // Placeholder image

  // Format: "Position at Organization" or just "Position" or just "Organization"
  const jobInfo = face.position && face.organization
    ? `${face.position} at ${face.organization}`
    : face.position || face.organization || '';

  return (
    <Card as={Link} to={`/face/${face.id}`} className="text-decoration-none text-dark h-100 shadow-sm">
      <Card.Img variant="top" src={imageUrl} alt={face.name} style={{ height: '180px', objectFit: 'cover' }} />
      <Card.Body>
        <Card.Title className="h5">{face.name}</Card.Title>
        {jobInfo && <Card.Text className="mb-0 text-muted">{jobInfo}</Card.Text>}
      </Card.Body>
    </Card>
  );
}

export default FaceCard;